
const Mensaje = () => ( 
    <p>
       Agrega una cantidad y un plazo a pagar para cotizar
    </p>
);

export default Mensaje;

